/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoResolveTicketInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type TicketShowResolveMutationVariables = {
    input: infoResolveTicketInput;
};
export type TicketShowResolveMutationResponse = {
    readonly infoResolveTicket: {
        readonly clientMutationId: string | null;
    } | null;
};
export type TicketShowResolveMutation = {
    readonly response: TicketShowResolveMutationResponse;
    readonly variables: TicketShowResolveMutationVariables;
};



/*
mutation TicketShowResolveMutation(
  $input: infoResolveTicketInput!
) {
  infoResolveTicket(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoResolveTicketPayload",
    "kind": "LinkedField",
    "name": "infoResolveTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TicketShowResolveMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TicketShowResolveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf46c8791b77d04d3f21dbea7996748e",
    "id": null,
    "metadata": {},
    "name": "TicketShowResolveMutation",
    "operationKind": "mutation",
    "text": "mutation TicketShowResolveMutation(\n  $input: infoResolveTicketInput!\n) {\n  infoResolveTicket(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '5e72e81a253567fc6ba7c41c7e74b1bf';
export default node;
